module.exports = __webpack_public_path__ + "static/media/13.55feef4d.jpg";